<!-- 设置表头 -->
<template>
    <div class="container containerBox">
        <div>
           <!-- <img width="100%" src="@/assets/bill_header.png" alt=""> -->
        </div>
        <el-form 
            :model="billForm" 
            :rules="billFormRules" 
            ref="billForm" 
            label-width="80px" 
            class="bill-setting-box"
            style="margin-top: 24px;">
            <el-form-item label="页眉说明" prop="header_description">
                <el-input type="textarea" v-model="billForm.header_description"></el-input>
            </el-form-item>
            <el-form-item label="收款单位" prop="collection_unit">
                <el-input type="input" v-model="billForm.collection_unit"></el-input>
            </el-form-item>
            <el-form-item label="账号" prop="account">
                <el-input type="input" v-model="billForm.account"></el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="deposit_bank">
                <el-input type="input" v-model="billForm.deposit_bank"></el-input>
            </el-form-item>
            <el-form-item label="说明1">
                <el-input type="textarea" v-model="billForm.first_description"></el-input>
            </el-form-item>
            <el-form-item label="说明2">
                <el-input type="textarea" v-model="billForm.second_description"></el-input>
            </el-form-item>
            <el-form-item style="margin-top: 24px;">
                    <el-button type="primary" size="medium" @click="handleBillFormSubmit">确定并保存</el-button>
                    <!-- <el-button size="medium">取消</el-button> -->
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Service from '@/api/Service'

export default {
    name: "settingheader",
    data() {
        return {
            billForm: {
                collection_unit: "",
                account: "",
                deposit_bank: "",
                header_description: "",
                first_description: "",
                second_description: ""
            },
            billFormRules: {
                collection_unit: {
                    // required: true,
                    message: "请输入收款单位",
                    trigger: "blur"
                },
                account: {
                    // required: true,
                    message: "请输入账号",
                    trigger: "blur"
                },
                deposit_bank: {
                    // required: true,
                    message: "请输入开户银行",
                    trigger: "blur"
                },
                header_description: {
                    required: true,
                    message: "请输入页眉说明",
                    trigger: "blur"
                },
            },
        };
    },
    created() {
        this.getData();
    },
    components: {},
    methods: {
        async getData() {
            let res = await Service.getBillset()
            if(res) {
                if(res.oid === 0) return
                this.billForm.header_description = res.header_description
                this.billForm.collection_unit = res.collection_unit
                this.billForm.account = res.account
                this.billForm.deposit_bank = res.deposit_bank
                this.billForm.first_description = res.first_description
                this.billForm.second_description = res.second_description
                // this.billForm.oid = res.oid
            }
        },
        handleBillFormSubmit() {
            this.$refs['billForm'].validate(async valid =>{
                if(valid) {
                    let res= await Service.editBillset(this.billForm)
                    if(res) {
                        this.$message({
                            message: '更新成功',
                            type: 'success',
                            duration: 2000,
                            onClose: () => {
                                this.getData();
                            }
                        });
                    }
                }else{
                    return false
                }
            })
        },
    }
};
</script>

<style scoped>
.bill-container {
    padding: 24px 32px;
    background: #fff;
}
.bill-setting-box {
    width: 600px;
    margin: auto;
}
</style>

